import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const api = axios.create({
  baseURL: BASE_URL,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}

// Re-attach on load if a token is already stored (e.g. page refresh)
const stored = typeof window !== "undefined" ? localStorage.getItem("wcc_token") : null;
if (stored) setAuthToken(stored);
